<template>

  <section class="main main-container">
    <div class="SvgsGroups">
      <div>
        <SvgIcon2 /> <span>ضمانت اصالت کالا</span>
      </div>
      <div>
        <SvgIcon1 class="icon-pay" /> <span>پرداخت آنلاین و مطمئن</span>
      </div>
      <div>
        <SvgIcon3 /> <span>ضمانت بازگشت کالا</span>
      </div>
      <div>
        <SvgIcon4 /> <span>ارسال پستی به سراسر ایران</span>
      </div>
    </div>
    <div class="SvgsGroupsMobile">
      <div class="swiper-container ">
        <div class="swiper-wrapper">
          <div class="swiper-slide ">
            <div class="svgBox">
              <SvgIcon2 /> <span>ضمانت اصالت کالا</span>
            </div>

          </div>
          <div class="swiper-slide ">
            <div class="svgBox">
              <SvgIcon1 class="icon-pay" /> <span>پرداخت آنلاین و مطمئن</span>
            </div>


          </div>
          <div class="swiper-slide ">
            <div class="svgBox">
              <SvgIcon3 /> <span>ضمانت بازگشت کالا</span>

            </div>


          </div>
          <div class="swiper-slide ">
            <div class="svgBox">
              <SvgIcon4 /> <span>ارسال پستی به سراسر ایران</span>

            </div>


          </div>
        </div>
      </div>
    </div>


  </section>
</template>
<script>
import Swiper from "swiper/swiper-bundle.min.js";

import SvgIcon1 from "@/parts/Front/components/shared/PDLI1.vue";
import SvgIcon2 from "@/parts/Front/components/shared/PDLI2.vue";
import SvgIcon3 from "@/parts/Front/components/shared/PDLI3.vue";
import SvgIcon4 from "@/parts/Front/components/shared/PDLI4.vue";


export default {
  name: "svgGroupSection",
  components: {
    SvgIcon1,
    SvgIcon2,
    SvgIcon3,
    SvgIcon4,

  },
  methods: {
    initPosts(kill = false) {
      this.initSwiper("svgGroupSection", kill, () => {
        new Swiper(".SvgsGroupsMobile .swiper-container", {
          spaceBetween: 30,

          loop: false,

          navigation: {
            nextEl: ".SvgsGroupsMobile  .swiper-button-next",
            prevEl: ".SvgsGroupsMobile  .swiper-button-prev",
          },

          breakpoints: {
            300: {
              slidesPerView: 1.8,
              spaceBetween: 30,
            },
            500: {
              slidesPerView: 2.5,
              spaceBetween: 15,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1280: {
              slidesPerView: 4,
              spaceBetween: 20,
            },

          },
        });
      });
    },

  },
  mounted() {
    this.initPosts();
  },


};
</script>
<style>
.main .swiper {
  padding-bottom: 4rem !important;

}

.SvgsGroupsMobile {
  display: none;
}

/*.SvgsGroups path,
.SvgsGroups .mainsvgcolor,
.SvgsGroups .mainsvgcolor,
.SvgsGroups rect {
  fill: #a02449;
}*/

.SvgsGroups>div>span {
  font-size: 13px;
}

/*.SvgsGroups .blckSvgColor {
  fill: #454b53;
}*/
</style>
<style scoped>
.main {

  margin-top: 50px;

}

.svgBox {
  display: flex;
  align-items: center;
  gap: 10px;

  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
    0 0 0 0 rgba(0, 0, 0, 0.12) !important;

  border-radius: 20px !important;
}

.SvgsGroups {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 70%;
  gap: 64px;
  margin: 6rem auto;

  justify-items: center;
}

@media screen and (max-width: 1200px) {
  .SvgsGroups {
    width: 80%;
  }
}

@media screen and (max-width: 768px) {
  .SvgsGroups {
    display: none;
  }

  .SvgsGroupsMobile {
    display: block;
  }

  .main {
    margin-top: 35px;
  }
}

@media screen and (max-width: 420px) {

  /*.SvgsGroups {
    gap: 64px;
    margin-top: 3rem;
  }*/
  .svgBox {
    font-size: 14px;
  }
}

@media screen and (max-width: 360px) {

  /*.SvgsGroups {
    gap: 64px;
    margin-top: 3rem;
  }*/
  .svgBox {
    font-size: 12px;
  }
}

.SvgsGroups div {
  transform: scale(1.2);
  text-align: center;
  display: flex;
  gap: 10px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.icon-pay {
  transform: translateY(8px);
}
</style>
